import { createFeature, createReducer } from '@ngrx/store';

import { jobMutateChargesReducer } from '../mutate-charges/mutate-charges.reducers';
import { jobMutateDiscountsReducer } from '../mutate-discount/mutate-discount.reducers';

import { jobMutateObjectReducers } from './mutate-object.reducers';
import { jobMutateObjectInitialState } from './mutate-object.state';

export const mutateObjectFeature = createFeature({
  name: 'jobV3MutateObject',
  reducer: createReducer(
    jobMutateObjectInitialState,
    ...jobMutateObjectReducers,
    ...jobMutateChargesReducer,
    ...jobMutateDiscountsReducer,
  ),
});
